module.exports = __webpack_public_path__ + "img/Systems_and_technology_programming_company_logo-removebg-preview.95266ffd.png";